import { Config, AuthHeader } from "../helpers/Config";
import { UserService } from "./UserService";

export const InternalTransferService = {
     /**
     * [INTERNAL_TRANSFER]
     * @param {object} data
     * @param {number} data.fromAccount
     * @param {number} data.toAccount
     * @param {number} data.amount
     * @param {boolean} data.allMargin
     */
    Create(data) {

        var requestOptions = {
            method: 'POST',
            headers: AuthHeader(),
            body: JSON.stringify(data)
        }
    
        return fetch(Config.service.internalTransfer.Create, requestOptions)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } 
                else if (response.status === 401) {

                    UserService.Logout();
                
                    window.location.reload();
                }
                else {
                    throw new Error();
                }
            }).then((json) => {
                return json;
            }).catch(function () {
                return false;
            });

    }
}
